// Rooted Strategy with Roisin Doyle — content from the brief.

export const BRAND = {
  name: "Rooted Strategy",
  subtitle: "with Roisin Doyle",
  tagline: "Strategy. Content. Community.",
};

export const CONTACT = {
  name: "Roisin Doyle",
  email: "roisin.rootedstrategy@gmail.com",
  phone: "087 369 2770",
  phoneHref: "+353873692770",
  location: "Ireland",
  community: "36,000+",
  tiktok: "@roisingemma",
  tiktokUrl: "https://www.tiktok.com/@roisingemma",
  linkedin: "Roisin Doyle",
  linkedinUrl: "https://www.linkedin.com/search/results/all/?keywords=Roisin%20Doyle",
};

export const IMAGES = {
  hero: "/roisin/hero.jpg",
  about: "/roisin/about.jpg",
  grad: "/roisin/grad.jpg",
};

export const HERO = {
  headline: "Helping brands grow through strategy, content and community.",
  subheading:
    "I work with startups, wellness brands and purpose-driven businesses to build visibility, strengthen brand positioning and create meaningful audience engagement through content strategy, marketing and community building.",
};

export const ABOUT_PARAS = [
  "I have a background in Health Science and a Master's in Adolescent Health, alongside experience working across content creation, digital marketing, community building and brand development.",
  "Over the past number of years, I have built and engaged an online community of more than 36,000 followers while creating content focused on wellness, recovery and personal growth. This experience has given me a strong understanding of audience behaviour, community engagement and authentic digital storytelling.",
  "I am passionate about helping purpose-driven brands communicate clearly, connect with their audience and build meaningful communities.",
  "My approach combines strategic thinking with creative execution to help businesses grow in an authentic and sustainable way.",
];

export const SERVICES = [
  { n: "01", title: "Content Strategy", desc: "Creating clear content plans, messaging frameworks and content systems aligned with business goals." },
  { n: "02", title: "Brand Strategy", desc: "Helping businesses clarify their positioning, messaging and customer experience." },
  { n: "03", title: "Website Development", desc: "Designing and building modern, professional websites that communicate clearly and generate enquiries." },
  { n: "04", title: "UGC Creation", desc: "Creating authentic content designed to build trust, engagement and brand awareness." },
  { n: "05", title: "Social Media Management", desc: "Content planning, scheduling, audience engagement and platform management." },
  { n: "06", title: "Community Building", desc: "Helping brands build loyal communities through meaningful engagement and audience connection." },
  { n: "07", title: "Brand Activation & Events", desc: "Supporting campaigns, workshops, launches and events that bring brands to life." },
  { n: "08", title: "B2B Partnerships", desc: "Identifying and developing strategic partnerships that increase visibility, credibility and growth opportunities." },
  { n: "09", title: "Startup Marketing", desc: "Supporting growing businesses with launch strategies, brand development and marketing support." },
  { n: "10", title: "Health & Wellness Marketing", desc: "Combining marketing expertise with a background in health science to support wellness and education-focused brands." },
  { n: "11", title: "Health Writing", desc: "Creating evidence-based content that translates complex topics into engaging, accessible communication." },
];

export const EXPERIENCE_REMOVED = true;

export const CREDENTIALS = [
  "Master's Degree in Adolescent Health",
  "Background in Health Science",
  "Built a Community of 36,000+ Followers",
  "Experience Across Wellness, Education and Startup Organisations",
  "Strong Understanding of Community Building",
  "Strategic and Creative Approach",
  "Passion for Purpose-Driven Brands",
];

export const PROCESS = [
  { n: "01", title: "Discovery", desc: "Understanding your business, audience and goals." },
  { n: "02", title: "Strategy", desc: "Developing a clear and practical growth plan." },
  { n: "03", title: "Creation", desc: "Building content, campaigns and marketing assets." },
  { n: "04", title: "Growth", desc: "Reviewing performance and refining the strategy over time." },
];

export const CONTACT_COPY = {
  heading: "Let's build something meaningful.",
  copy:
    "Whether you're launching a new brand, growing an existing business or looking for support with content, strategy or marketing, I'd love to hear from you.",
};
